<!-- 权责清单头部搜索组件 -->
<template>
    <div class="v-header">
        <div class="header-nav">
            <div class="header-nav-logo">
                <router-link to="/accrual">
                    <img src="../../assets/pkulaw.png" alt="">
                </router-link>
            </div>
            <div class="header-nav-title">
                <router-link to="/accrual">
                    <h1>北大法宝权责清单智能管理系统</h1>
                </router-link>
            </div>
            <div class="header-nav-login">
                <Button ghost @click="toAccrual">{{ userMsg.phoneNum }}</Button>
                <Button ghost @click="toIntroduce">系统介绍</Button>
                <!-- <Button>注册试用</Button> -->
            </div>
        </div>
        <div class="header-bg-group">
            <div class="header-tabs" v-if="isShowSearch == 1 || isShowSearch == 4">
                <router-link to="accrual" :class="{'tabs-active': isShowSearch == 1}">权力清单</router-link>
                <router-link to="" disabled>责任清单</router-link>
                <router-link to="negative" :class="{'tabs-active': isShowSearch == 4}">负面清单</router-link>
            </div>
            <div class="header-bg" v-if="isShowSearch != 3">
                <!-- <div class="header-search-title" v-if="isShowSearch == 1">权责清单</div> -->
                <Input v-if="isShowSearch == 1 || isShowSearch == 4" v-model="Keyword" search enter-button="搜索"
                    placeholder="请输入职权名称" clearable @on-search="callbackReq" @on-clear="callbackReq" />
                <span class="header-bg-text" v-if="isShowSearch == 2">系统简介</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'VHeader',
        components: {

        },
        props: {
            // 小驼峰命名
            isShowSearch: {
                type: String,
                default() {
                    return '3'
                }
            }
        },
        data() {
            return {
                // 查询参数
                Keyword: "",
                userMsg: {
                    phoneNum: ''
                }
            }
        },
        computed: {},
        mounted() {
            if (this.getStore('UserMes')) {
                this.userMsg = JSON.parse(this.getStore('UserMes'));

            }
        },
        methods: {
            toAccrual() {
                // this.$router.push({path: '/accrual'});
            },
            toIntroduce() {
                this.$router.push({ path: '/introduce' });
            },
            // 返回参数,返回搜索框参数给父组件Accrual
            callbackReq() {
                this.$emit("buildAccrualListReq", {
                    keyword: this.Keyword,
                    // pageSize: 10,
                    // pageNum: 1
                }, 'search');
            }
        }
    }
</script>

<style scoped>
    .v-header {
      background-color: #fff;
    }
    .header-nav {
        overflow: hidden;
        padding: 0 80px 0 40px;
        height: 50px;
        line-height: 50px;
    }

    .header-nav-logo {
        float: left;
        /* padding-top: 30px; */
    }

    .header-nav-logo img {
      width: 100%;
      height: 46px;
    }

    .header-nav-title {
        float: left;
        padding-left: 35px;
    }

    .header-nav-login {
        float: right;
    }

    .header-nav-title h1 {
        font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
        font-size: 22px;
        font-weight: 400;
        color: #2d4060;
    }

    .header-bg-group {
        overflow: hidden;
        background: url(../../assets/search-bg.png) no-repeat right 0;
        background-size: 100% 100%;
    }

    .header-bg {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0px auto 0;
        width: 1200px;
        height: 110px;
    }

    .header-search-title {
        padding: 0 20px;
        font-family: 'SimSun', 'Microsoft Yahei', Arial, Helvetica, sans-serif;
        font-size: 36px;
        color: #fff;
    }

    .header-bg .ivu-input-group {
        width: 68%;
    }

    .header-bg-text {
        margin: 0 auto;
        width: 144px;
        font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
        font-size: 30px;
        font-weight: bold;
        color: #fff;
    }

    .header-tabs {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: 50px;
        margin: 0 0 -26px 0;
    }

    .header-tabs a {
        margin: 0px 55px 6px 0;
        font-size: 18px;
        color: #fff;
    }

    .header-tabs a[disabled] {
        color: #dcdcdc;
    }

    .header-tabs a:hover {
        border-bottom: 2px solid #fff;
        font-size: 18px;
        color: #fff;
    }

    .header-tabs .tabs-active {
        border-bottom: 2px solid #fff;
        font-size: 18px;
        color: #fff;
    }
</style>